import React, { useState } from "react";
import "./WPSlider.scss";

const WPSlider = ({
  min,
  max,
  displayMin,
  displayMax,
  defaultValue,
  value: controlledValue,
  onChange,
  disabled = false,
  step,
}) => {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? Number(controlledValue) : internalValue;

  const resolvedStep = step ?? (Number.isInteger(min) && Number.isInteger(max) ? 1 : "any");

  // When step is numeric, the browser snaps the thumb to the nearest step from min.
  // Compute fillPct from the snapped value so the fill gradient tracks the thumb exactly.
  const snappedValue = (() => {
    const clamped = Math.min(max, Math.max(min, isNaN(value) ? min : value));
    if (resolvedStep === "any" || resolvedStep === 0) return clamped;
    const steps = Math.round((clamped - min) / resolvedStep);
    return Math.min(max, Math.max(min, min + steps * resolvedStep));
  })();

  const fillPct = ((snappedValue - min) / (max - min)) * 100;
  // Compute fill stop in JS to avoid SCSS calc() parsing issues.
  // Browser thumb center travels from thumbRadius to trackWidth-thumbRadius,
  // so fill stop = pct * (100% - thumbSize) / 100 + thumbSize/2.
  const THUMB_PX = 16;
  const fillStop = `calc(${fillPct.toFixed(4)} * (100% - ${THUMB_PX}px) / 100 + ${THUMB_PX / 2}px)`;

  const handleChange = (e) => {
    const val = Number(e.target.value);
    if (!isControlled) setInternalValue(val);
    onChange?.(val);
  };

  return (
    <div className="wp-slider">
      <span className="slider-side-label">{displayMin ?? min}</span>
      <div
        className={`slider-track ${disabled ? "disabled" : ""}`}
        style={{ "--fill-stop": fillStop }}
      >
        <input
          className="slider-input"
          type="range"
          min={min}
          max={max}
          step={resolvedStep}
          value={value}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>
      <span className="slider-side-label">{displayMax ?? max}</span>
    </div>
  );
};

export default WPSlider;
